import { useParams, useNavigate } from 'react-router-dom';
import { useJob } from '@/hooks/useJobs';
import { Layout } from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { JobDetailContent } from '@/components/jobs/JobDetailContent';

export default function JobDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: job, isLoading } = useJob(id || null);

  if (isLoading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[400px]">
          <p className="text-muted-foreground">Loading job details...</p>
        </div>
      </Layout>
    );
  }

  if (!job) {
    return (
      <Layout>
        <div className="space-y-4">
          <Button variant="ghost" size="sm" onClick={() => navigate('/jobs')} className="gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Jobs
          </Button>
          <div className="text-center py-12">
            <p className="text-muted-foreground">Job not found</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6 pb-8">
        {/* Back Button */}
        <Button variant="ghost" size="sm" onClick={() => navigate('/jobs')} className="gap-2">
          <ArrowLeft className="h-4 w-4" />
          Back to Jobs
        </Button>
        
        {/* Full Job Detail Content */}
        <JobDetailContent 
          job={job} 
          isSheet={false} 
          onDeleted={() => navigate('/jobs')}
        />
      </div>
    </Layout>
  );
}
